<script setup lang="ts">
/*---------------------------------------------
/  PROPS & EMITS
---------------------------------------------*/
/*---------------------------------------------
/  VARIABLES
---------------------------------------------*/
const originalTitle = ref('');
const originalDescription = ref('');
const originalShareImage = ref('');
const originalTheme = ref('');
const metaStore = useMetaStore();
/*---------------------------------------------
/  METHODS
---------------------------------------------*/
const removeOriginalMetaTags = () => {
	originalTitle.value = document.querySelector('title')?.innerText || '';
	originalDescription.value =
		document
			.querySelector('meta[name="description"]')
			?.getAttribute('content') || '';
	originalShareImage.value =
		document
			.querySelector('meta[property="og:image"]')
			?.getAttribute('content') || '';

	if (originalShareImage.value) {
		originalShareImage.value =
			window.location.origin + originalShareImage.value;
	}

	document.querySelector('title')?.remove();
	document.querySelector('meta[name="description"]')?.remove();
	document.querySelector('meta[name="theme-color"]')?.remove();
	document.querySelector('meta[property="og:title"]')?.remove();
	document.querySelector('meta[property="og:description"]')?.remove();
	document.querySelector('meta[property="og:image"]')?.remove();
};
/*---------------------------------------------
/  COMPUTED
---------------------------------------------*/
const meta = computed(() => {
	return metaStore.meta;
});
/*---------------------------------------------
/  WATCHERS
---------------------------------------------*/
/*---------------------------------------------
/  CREATED
---------------------------------------------*/
/*---------------------------------------------
/  HOOKS
---------------------------------------------*/
onMounted(() => {
	removeOriginalMetaTags();
});
</script>

<template>
	<teleport to="head">
		<title v-if="meta?.title">
			{{ meta?.title ? meta?.title + ' | ' + originalTitle : '' }}
		</title>
		<title v-else>
			{{ originalTitle }}
		</title>

		<meta
			v-if="meta?.ogTitle || meta?.title"
			property="og:title"
			:content="
				meta?.ogTitle || meta?.title
					? (meta?.ogTitle || meta?.title) + ' | ' + originalTitle
					: ''
			" />

		<meta
			v-if="meta?.description"
			name="description"
			:content="meta?.description" />
		<meta
			v-else
			name="description"
			:content="originalDescription" />

		<meta
			v-if="meta?.theme"
			name="theme-color"
			:content="meta?.theme" />
		<meta
			v-else
			name="theme-color"
			:content="originalTheme" />

		<meta
			v-if="meta?.ogDescription || meta?.description"
			property="og:description"
			:content="meta?.ogDescription || meta?.description" />

		<meta
			v-if="meta?.ogImage"
			property="og:image"
			:content="meta?.ogImage" />
		<meta
			v-else
			property="og:image"
			:content="originalShareImage" />
	</teleport>
</template>
